<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <validationObserver ref="addDataForm" tag="form">
      <form v-if="mode == 'new' || mode == 'edit'" @submit.prevent="onSubmit">
        <div class="row">
          <div class="col-xl-4">
            <div class="card">
              <div class="card-body">
                <div class="media">
                  <div class="media-body">
                    <div class="text-muted">
                      <h5>Tech Product</h5>
                      <h5 class="ml-2">
                        <span class="font-size-14 text-muted">Name: </span
                        >{{ model.display_name }}
                      </h5>
                      <p class="mb-0 ml-2">
                        Service from: ({{ model.application_info.code }})
                        {{ model.service_info.service_name }}
                      </p>
                      <p class="mb-0 ml-2">
                        {{ model.service_info.service_domain }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-body">
                <div
                  v-if="
                    clientAppsData && Object.keys(clientAppsData).length > 0
                  "
                  class="media"
                >
                  <div class="media-body">
                    <h5>Client Apps</h5>
                    <h5 class="ml-2">
                      <span class="font-size-14 text-muted">Name: </span
                      >{{ clientAppsData.display_name }}
                    </h5>
                    <div class="mb-0 ml-2">
                      Domains:
                      <template
                        v-for="(item, index) in clientAppsData.app_domains"
                      >
                        <b-alert
                          show
                          small
                          variant="secondary"
                          class="col-4 col-sm-12"
                          v-bind:key="index"
                        >
                          {{ item }}</b-alert
                        >
                      </template>
                    </div>
                    <p class="mb-0 ml-2">
                      App Namespace: {{ clientAppsData.app_namespace }}
                    </p>
                    <p class="mb-0 ml-2">
                      Contact Email: {{ clientAppsData.contact_email }}
                    </p>
                  </div>
                </div>
                <div v-else class="media">
                  <div class="media-body">
                    <h5>Client Apps</h5>
                    <div class="text-sm-left">
                      <button
                        @click="toggleSideBar = !toggleSideBar"
                        type="button"
                        class="btn btn-sm btn-success waves-effect waves-light ml-2"
                      >
                        <i class="fa fa-plus"></i>
                        Add Client Apps
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="model.tech_product_type === 'OAuth'" class="col-xl-8">
            <oauth-component
              ref="oauthEditor"
              v-model="oauthModel"
              :isChanged.sync="isOauthPayloadChanged"
            ></oauth-component>
          </div>
          <div v-else class="col-xl-8">
            <div v-if="isTechProductParameterOptions" class="card">
              <div class="card-body">
                <h4 class="card-title mb-3">Tech Product Parameters</h4>
                <div>
                  <div class="row col-lg-12">
                    <div
                      v-for="(data, index) in techProductParameterOptions"
                      :key="index"
                      class="inner mb-3 row col-md-12"
                    >
                      <div class="col-12 row">
                        <label class="col-form-label col-md-3">{{
                          data.display_name
                        }}</label>
                        <div class="col-md-5">
                          <basic-select
                            :reload="reloadStatusSelector"
                            :options="
                              data.parameter_options.map(
                                ({ data_key, data_value }) => ({
                                  value: data_key,
                                  text: data_value,
                                })
                              )
                            "
                            :selected-option="{
                              text: data.selected.text,
                              value: data.selected.value,
                            }"
                            @select="onStatusSelector($event, data)"
                            placeholder="ระบุ"
                          >
                          </basic-select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="isGrantRolebindingCrossPlatformOptions" class="card">
              <div class="card-body">
                <h4 class="card-title mb-3">
                  Grant Rolebinding Cross Platform
                </h4>
                <div>
                  <div class="row col-lg-12">
                    <template v-if="isCrossTechProductParameters">
                      <div
                        v-for="(
                          item, index
                        ) in grantRolebindingCrossPlatformSelected"
                        :key="index"
                        class="inner mb-3 row col-md-12"
                      >
                        <div class="col-md-5">
                          <basic-select
                            :reload="reloadCrossTechProductSelector"
                            :options="
                              filterGrantRolebindingCrossPlatformOptions(item)
                            "
                            :selected-option="{
                              text: item.custom_param_key,
                              value: item.custom_param_value,
                            }"
                            @select="onCrossTechProductSelector($event, item)"
                            placeholder="ระบุ"
                          >
                          </basic-select>
                        </div>
                        <div class="col-md-4">
                          <button
                            type="button"
                            class="btn btn-danger"
                            @click="deleteCrossTechParameter(index)"
                          >
                            <i class="bx bx-trash" />Delete
                          </button>
                        </div>
                      </div>
                    </template>
                    <div class="col-12">
                      <input
                        v-show="!isEmptyCrossTechProductParameters"
                        type="button"
                        class="btn btn-sm btn-success inner"
                        value="Add more"
                        @click="addCrossTechParameter"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-body">
                <h4 class="card-title mb-3">Custom Parameters</h4>
                <div class="row col-lg-12">
                  <div class="col-12">
                    <div
                      v-for="(data, index) in customParameterOptions"
                      :key="index"
                      class="inner mb-3 row"
                    >
                      <div class="col-md-4 col-4">
                        <validationProvider
                          :vid="`custom_param_key_${index}`"
                          v-slot="{ errors }"
                          name="Custom Parameter Key"
                          :rules="{
                            required: true,
                            validateSeriesAndAttributeEngWithSpecialCharacters: true,
                          }"
                        >
                          <input
                            v-model="data.custom_param_key"
                            type="text"
                            class="inner form-control"
                            placeholder="Enter Key"
                            :class="{
                              'is-invalid': errors && errors.length,
                              'is-valid':
                                !(errors && errors.length) &&
                                data.custom_param_key,
                            }"
                          />
                          <div
                            v-if="errors && errors.length"
                            class="invalid-feedback"
                          >
                            <span>{{ errors[0] }}</span>
                          </div>
                        </validationProvider>
                      </div>
                      <div class="col-md-6 col-4">
                        <validationProvider
                          :vid="`custom_param_value_${index}`"
                          v-slot="{ errors }"
                          name="Custom Parameter Value"
                          :rules="{ required: true }"
                        >
                          <input
                            v-model="data.custom_param_value"
                            type="text"
                            class="inner form-control"
                            placeholder="Enter Value"
                            :class="{
                              'is-invalid': errors && errors.length,
                              'is-valid':
                                !(errors && errors.length) &&
                                data.custom_param_value,
                            }"
                          />
                          <div
                            v-if="errors && errors.length"
                            class="invalid-feedback"
                          >
                            <span>{{ errors[0] }}</span>
                          </div>
                        </validationProvider>
                      </div>
                      <div class="col-md-2 col-2">
                        <button
                          type="button"
                          class="btn btn-danger"
                          @click="deleteParameter(index)"
                        >
                          <i class="bx bx-trash" />Delete
                        </button>
                      </div>
                    </div>
                    <input
                      type="button"
                      class="btn btn-sm btn-success inner"
                      value="Add more parameter"
                      @click="addParameter"
                    />
                  </div>
                </div>
              </div>
            </div>

            <!-- <div
              class="card"
              v-if="
                techProductClientApp.apps_config &&
                techProductClientApp.apps_config.client_access_token
              "
            > -->
            <div class="card">
              <div class="card-body">
                <h4 class="card-title mb-3">Custom Access Token</h4>
                <div>
                  <div class="input-group mb-3">
                    <label class="col-form-label col-lg-4"
                      >Validate Token (Revoke Token)</label
                    >
                    <div class="col-lg-7 mt-2">
                      <b-form-checkbox
                        :checked="accessToken.isStrictToken"
                        switch
                        @change="onChangeCheckedValidateToken($event)"
                      />
                    </div>
                  </div>
                  <div class="input-group mb-3">
                    <label class="col-form-label col-lg-4"
                      >Default (10 Years)</label
                    >
                    <div class="col-lg-7 mt-2">
                      <b-form-checkbox
                        :checked="accessToken.isDefault"
                        switch
                        @change="onChangeChecked($event)"
                      />
                    </div>
                  </div>
                  <div v-show="!accessToken.isDefault" class="input-group">
                    <label class="col-form-label col-lg-3"
                      >Time to live(TTL)</label
                    >
                    <div class="col-lg-7">
                      <div class="row">
                        <div class="col-lg-10">
                          <validationProvider
                            v-slot="{ errors }"
                            ref="label_token_expiry"
                            name="Token Expiry"
                            :rules="{
                              required: true,
                            }"
                          >
                            <b-form-input
                              id="label_token_expiry"
                              value="5256000"
                              type="number"
                              name="label_token_expiry"
                              v-model="accessToken.ttl"
                              :disabled="accessToken.isDefault"
                              :class="{
                                'is-invalid': errors && errors.length,
                                'is-valid':
                                  !(errors && errors.length) && accessToken.ttl,
                              }"
                            ></b-form-input>
                            <div
                              v-if="errors && errors.length"
                              class="invalid-feedback"
                            >
                              <span>{{ errors[0] }}</span>
                            </div>
                          </validationProvider>
                        </div>
                        <div class="col-lg-2 mb-3">
                          <label class="col-form-label">minutes</label>
                        </div>
                        <div class="col-lg-12">
                          <div class="btn-group btn-group-example" role="group">
                            <b-button
                              v-for="(item, index) in ttlOptions"
                              :key="index"
                              variant="outline-secondary"
                              class="w-sm"
                              :disabled="accessToken.isDefault"
                              @click="accessToken.ttl = item.value"
                            >
                              {{ item.name }}
                            </b-button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- <input
                      id="access_token_copy"
                      type="text"
                      class="form-control col-md-11"
                      style="
                        color: #004085;
                        background-color: #cce5ff;
                        border-color: #b8daff;
                      "
                      v-model="
                        techProductClientApp.apps_config.client_access_token
                      "
                      readonly="true"
                    />
                    <button
                      class="input-group-button btn-secondary waves-effect waves-light col-md-1"
                      type="button"
                      @click="copyText"
                    >
                      <i class="fas fa-copy"></i>
                    </button>
                    <button
                      type="button"
                      class="btn btn-light ml-3"
                      @click="resetAccessToken"
                    >
                      <i class="bx bx-reset" />Reset
                    </button> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="text-left">
              <div class="button-items">
                <button type="button" class="btn btn-light" @click="onBack()">
                  <i class="bx bx-arrow-back" />
                  Back
                </button>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="text-right">
              <div class="button-items">
                <button type="submit" class="btn btn-primary">
                  <i class="bx bx-save" />Save
                </button>
                <!-- <button type="reset" class="btn btn-light">
                          <i class="bx bx-reset" />Reset
                        </button> -->
              </div>
            </div>
          </div>
        </div>
      </form>
    </validationObserver>
    <template v-if="mode == 'view'">
      <div class="row">
        <div class="col-md-12">
          <div class="text-right mb-2">
            <div class="button-items">
              <button
                @click="onClickedEditParameters"
                type="button"
                class="btn btn-warning waves-effect waves-light"
              >
                <i class="mdi mdi-pencil label-icon"></i>
                Edit Configuration
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xl-4">
          <div class="card">
            <div class="card-body">
              <div class="media">
                <div class="media-body">
                  <div class="text-muted">
                    <h5>Tech Product</h5>
                    <h5 class="ml-2">
                      <span class="font-size-14 text-muted">Name: </span
                      >{{ model.display_name }}
                    </h5>
                    <p class="mb-0 ml-2">
                      Service from: ({{ model.application_info.code }})
                      {{ model.service_info.service_name }}
                    </p>
                    <p class="mb-0 ml-2">
                      {{ model.service_info.service_domain }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-body">
              <div
                v-if="clientAppsData && Object.keys(clientAppsData).length > 0"
                class="media"
              >
                <div class="media-body">
                  <h5>Client Apps</h5>
                  <h5 class="ml-2">
                    <span class="font-size-14 text-muted">Name: </span
                    >{{ clientAppsData.display_name }}
                  </h5>
                  <div class="mb-0 ml-2">
                    Domains:
                    <template
                      v-for="(item, index) in clientAppsData.app_domains"
                    >
                      <b-alert
                        show
                        small
                        variant="secondary"
                        class="col-4 col-sm-8"
                        :key="index"
                      >
                        {{ item }}</b-alert
                      >
                    </template>
                  </div>
                  <p class="mb-0 ml-2">
                    App Namespace: {{ clientAppsData.app_namespace }}
                  </p>
                  <p class="mb-0 ml-2">
                    Contact Email: {{ clientAppsData.contact_email }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="model.tech_product_type === 'OAuth'" class="col-xl-8">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title mb-3">Valid OAuth Redirect URIs</h4>
              <div class="col-sm-6">
                <template v-for="(item, index) in oauthModel.validRedirectURIs">
                  <b-alert show variant="success" :key="index">
                    {{ item.uri }}</b-alert
                  >
                </template>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-body">
              <h4 class="card-title mb-3">Channel Allows</h4>
              <div class="row col-lg-12">
                <div class="col-12">
                  <h4 class="card-title">Basic</h4>
                  <b-form>
                    <div class="row">
                      <div class="col-md-4">
                        <b-form-group
                          label="AD"
                          label-for="horizontal-firstname-input"
                          label-cols-sm="6"
                        >
                          <switches
                            v-model="oauthModel.channelAllows.Basic.AD"
                            type-bold="false"
                            color="warning"
                            class="ml-1 mb-0 mt-2 switches-channel"
                            disabled
                          ></switches>
                        </b-form-group>
                      </div>
                      <div class="col-md-4">
                        <b-form-group
                          label="Phone"
                          label-for="horizontal-firstname-input"
                          label-cols-sm="6"
                        >
                          <switches
                            v-model="oauthModel.channelAllows.Basic.Phone"
                            type-bold="false"
                            color="primary"
                            class="ml-1 mb-0 mt-2 switches-channel"
                            disabled
                          ></switches>
                        </b-form-group>
                      </div>
                      <div class="col-md-4">
                        <b-form-group
                          label="Email"
                          label-for="horizontal-firstname-input"
                          label-cols-sm="6"
                        >
                          <switches
                            v-model="oauthModel.channelAllows.Basic.Email"
                            type-bold="false"
                            color="success"
                            class="ml-1 mb-0 mt-2 switches-channel"
                            disabled
                          ></switches>
                        </b-form-group>
                      </div>
                    </div>
                  </b-form>

                  <p></p>
                  <h4 class="card-title">OAuth</h4>
                  <b-form>
                    <div class="row">
                      <div class="col-md-4">
                        <b-form-group
                          label="Facebook"
                          label-for="horizontal-firstname-input"
                          label-cols-sm="6"
                        >
                          <switches
                            v-model="oauthModel.channelAllows.OAuth.Facebook"
                            type-bold="true"
                            color="info"
                            class="ml-1 mb-0 mt-2 switches-channel"
                            disabled
                          ></switches>
                        </b-form-group>
                      </div>
                      <div class="col-md-4">
                        <b-form-group
                          label="Google"
                          label-for="horizontal-firstname-input"
                          label-cols-sm="6"
                        >
                          <switches
                            v-model="oauthModel.channelAllows.OAuth.Google"
                            readonly
                            type-bold="false"
                            color="danger"
                            class="ml-1 mb-0 mt-2 switches-channel"
                            disabled
                          ></switches>
                        </b-form-group>
                      </div>
                    </div>
                  </b-form>

                  <p></p>
                  <h4 class="card-title">Apps</h4>
                  <b-form>
                    <div class="row">
                      <div class="col-md-4">
                        <b-form-group
                          label="Client Apps"
                          label-for="horizontal-firstname-input"
                          label-cols-sm="6"
                        >
                          <switches
                            v-model="oauthModel.channelAllows.Apps.ClientApps"
                            type-bold="true"
                            color="secondary"
                            class="mb-0 switches-channel"
                            disabled
                          ></switches>
                        </b-form-group>
                      </div>
                    </div>
                  </b-form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="col-xl-8">
          <div v-if="isTechProductParameterOptions" class="card">
            <div class="card-body">
              <h4 class="card-title mb-3">Tech Product Parameters</h4>
              <div>
                <div class="row col-lg-12">
                  <div
                    v-for="(data, index) in techProductParameterOptions"
                    :key="index"
                    class="inner mb-3 row col-md-12"
                  >
                    <div class="col-12 row">
                      <label class="col-form-label col-md-4">{{
                        data.display_name
                      }}</label>
                      <div class="col-md-5">
                        <label class="col-form-label">
                          {{ dataParameterOptions(data) }}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="isGrantRolebindingCrossPlatformOptions" class="card">
            <div class="card-body">
              <h4 class="card-title mb-3">Grant Rolebinding Cross Platform</h4>
              <div>
                <div class="row col-lg-12">
                  <div class="inner row col-md-12">
                    <label class="col-form-label col-md-12"
                      >Application ที่จะให้เข้าถึง</label
                    >
                  </div>
                  <div
                    v-for="(
                      data, index
                    ) in grantRolebindingCrossPlatformSelected"
                    :key="index"
                    class="inner row col-md-12"
                  >
                    <label class="col-form-label col-md-12">
                      - {{ data.custom_param_key }}</label
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="isTechProductCustomParameters" class="card">
            <div class="card-body">
              <h4 class="card-title mb-3">Custom Parameters</h4>
              <div>
                <div
                  v-for="(data, index) in techProductCustomParameters"
                  :key="index"
                  class="col-12 row"
                >
                  <label class="col-md-3">{{ data.data_key }}</label>
                  <label class="col-md-5">
                    {{ data.data_value }}
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div
            class="card"
            v-if="
              techProductClientApp.apps_config &&
              techProductClientApp.apps_config.client_access_token
            "
          >
            <div class="card-body">
              <h4 class="card-title mb-3">Access Token</h4>
              <div>
                <div class="input-group">
                  <input
                    v-if="isShowAccessToken"
                    id="access_token_copy"
                    type="text"
                    class="form-control col-md-11"
                    style="
                      color: #004085;
                      background-color: #cce5ff;
                      border-color: #b8daff;
                    "
                    v-model="
                      techProductClientApp.apps_config.client_access_token
                    "
                    readonly="true"
                  />
                  <button
                    id="tooltip-target-2"
                    class="btn input-group-button btn-secondary waves-effect waves-light col-md-1"
                    type="button"
                    @click="showAccessTokenText"
                  >
                    <i
                      class="fas"
                      :class="isShowAccessToken ? 'fa-eye' : 'fa-eye-slash'"
                    ></i>
                  </button>
                  <b-tooltip target="tooltip-target-2" triggers="hover">
                    {{ isShowAccessToken ? textHideAccessTokenTooltipCopy : textShowAccessTokenTooltipCopy }}
                  </b-tooltip>
                  <button
                    v-if="isShowAccessToken"
                    class="btn input-group-button btn-secondary waves-effect waves-light col-md-1 ml-1"
                    type="button"
                    @click="copyText"
                    id="tooltip-target-1"
                  >
                    <i class="fas fa-copy"></i>
                  </button>
                  <b-tooltip target="tooltip-target-1" triggers="hover">
                    {{ textTooltipCopy }}
                  </b-tooltip>
                  <button
                    v-if="isShowAccessToken"
                    type="button"
                    class="btn btn-light ml-3"
                    @click="confirmResetAccessToken"
                  >
                    <i class="bx bx-reset" />Reset
                  </button>
                </div>
              </div>
            </div>
          </div>
          <Permissions
            :techProductId="id"
            :clientAppsId="$route.params.client_apps_id"
            :techProductClientAppId="techProductClientApp.id"
          ></Permissions>
        </div>
      </div>
      <div class="row mb-4">
        <div class="col-md-6">
          <div class="text-left">
            <div class="button-items">
              <button type="button" class="btn btn-light" @click="onBack()">
                <i class="bx bx-arrow-back" />
                Back
              </button>
            </div>
          </div>
        </div>
      </div>
    </template>

    <sideBar
      ref="sideBar"
      :toggleSideBar="toggleSideBar"
      @clientAppsSelected="onClientAppsSelected"
      @hidden="toggleSideBar = false"
    ></sideBar>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import Switches from "vue-switches";

import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import techProductService from "@/helpers/service/tech-products-service";
import clientAppsService from "@/helpers/service/client-apps-service";
import { eventBus } from "@/main.js";
import { BasicSelect } from "vue-search-select";
import oauth_component from "@/components/tech-product/oauth";
import { StatusEnum } from "@/enum/status.enum.js";
import sideBar from "@/components/tech-product/sideBar";
import Permissions from "@/components/tech-product/permissions.vue";
import * as jwt from "@/helpers/utils/jwt";

export default {
  page: {
    title: "Apply Client Apps",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    "basic-select": BasicSelect,
    sideBar,
    "oauth-component": oauth_component,
    Permissions,
    Switches,
  },
  data() {
    return {
      id: "",
      title: "Apply Client Apps",
      mode: "view",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Tech Products",
          href: "/tech-products",
        },
        {
          text: "Apply Client Apps",
          active: true,
        },
      ],
      reloadTypeSelector: false,
      modelOriginal: {},
      model: {
        id: "",
        application_id: "",
        service_id: "",
        application_info: {
          code: "",
          display_name: "",
        },
        service_info: {
          service_name: "",
          service_domain: "",
        },
        display_name: "",
        tech_product_type: "",
        default_permissions: [
          {
            id: "",
            display_name: "",
            version: "",
            area: "",
            controller: "",
            method: "",
            action: "",
            type: "",
          },
        ],
        status: "",
      },
      fields: [{ id: 1, isValidate: { value_en: false, value_th: false } }],
      isValidate: {
        display_name_th: false,
        display_name: false,
        contact_email: false,
        status: false,
      },
      reloadStatusSelector: false,
      reloadCrossTechProductSelector: false,
      toggleSideBar: false,
      clientAppsData: {},
      techProductParameterOptions: [],
      customParameterOptions: [],
      OriginalTechProductParameterOptions: [],
      OriginalCustomParameterOptions: [],
      techProductClientApp: {},
      techProductParameters: [],
      techProductCustomParameters: [],
      textTooltipCopy: "Copy",
      textShowAccessTokenTooltipCopy: "Show Access Token",
      textHideAccessTokenTooltipCopy: "Hide Access Token",
      oauthModel: {
        validRedirectURIs: [],
        channelAllows: {
          OAuth: {
            Facebook: false,
            Google: false,
          },
          Basic: {
            AD: true,
            Phone: false,
            Email: false,
          },
          Apps: {
            ClientApps: false,
          },
        },
      },
      isOauthPayloadChanged: false,
      grantRolebindingCrossPlatformSelected: [],
      OriginalGrantRolebindingCrossPlatformSelected: [],
      grantRolebindingCrossPlatformOptions: [],
      accessToken: {
        isStrictToken: false,
        isDefault: true,
        ttl: 5256000,
      },
      OriginalAccessToken: {},
      ttlOptions: [
        { name: "1 ชั่วโมง", value: 60 },
        { name: "1 วัน", value: 1440 },
        { name: "1 ปี", value: 525600 },
        { name: "10 ปี", value: 5256000 },
      ],
      isShowAccessToken: false,
    };
  },
  computed: {
    isTechProductCustomParameters() {
      return this.$validate.anyArrayObjectValid(
        this.techProductCustomParameters
      );
    },
    isCrossTechProductParameters() {
      return this.$validate.anyArrayObjectValid(
        this.grantRolebindingCrossPlatformSelected
      );
    },
    isEmptyCrossTechProductParameters() {
      return this.grantRolebindingCrossPlatformSelected.some(
        (q) => !this.$validate.isValid(q.custom_param_key)
      );
    },
    isGrantRolebindingCrossPlatformOptions() {
      return this.$validate.anyArrayObjectValid(
        this.grantRolebindingCrossPlatformOptions
      );
    },
    isTechProductParameterOptions() {
      return this.$validate.anyArrayObjectValid(
        this.techProductParameterOptions
      );
    },
  },
  created: function () {
    if (this.$route.params.client_apps_id == "new") {
      this.mode = "new";
      this.title = "APPLY CLIENT APPS";
      this.items[2].text = "New";
      setTimeout(() => {
        document.title = `APPLY Client Apps Tech Products | ${appConfig.description}`;
      }, 100);
    } else {
      this.title = "Apply Detail";
      this.items[2].text = "Apply Detail";
      this.id = this.$route.params.id;
      this.getTechProductClientAppsDetailAsync();
      this.onClientAppsSelected(this.$route.params.client_apps_id);
      setTimeout(() => {
        document.title = `Apply Detail | ${appConfig.description}`;
      }, 100);
    }
    // if (this.$route.query.mode) {
    //   this.title = "Edit TechProducts";
    //   this.items[2].text = "Edit";
    //   this.mode = this.$route.query.mode;
    // }
  },
  mounted: function () {
    this.onPageLoaded();

    //mock the

    // this.onClientAppsSelected("628c9a1d5d56eb7aaa581ebc");
  },
  methods: {
    onChangeCheckedValidateToken(checked) {
      this.accessToken.isStrictToken = checked;
    },
    onChangeChecked(checked) {
      this.accessToken.isDefault = checked;
    },
    addCrossTechParameter() {
      this.grantRolebindingCrossPlatformSelected.push({
        custom_param_key: "",
        custom_param_value: "",
      });
    },
    filterGrantRolebindingCrossPlatformOptions(selectedItem = null) {
      if (
        this.$validate.anyArrayObjectValid(
          this.grantRolebindingCrossPlatformSelected
        ) &&
        this.$validate.anyArrayObjectValid(
          this.grantRolebindingCrossPlatformOptions
        )
      ) {
        let values = this.grantRolebindingCrossPlatformSelected
          .filter((q) => this.$validate.isValid(q.custom_param_value))
          .map((q) => q.custom_param_value);

        if (this.$validate.isObjectValid(selectedItem)) {
          values = values.filter((s) => s !== selectedItem.custom_param_value);
        }
        let result = this.grantRolebindingCrossPlatformOptions
          .filter((q) => !values.includes(q.data_key))
          .map((q) => {
            return { value: q.data_key, text: q.data_value };
          });
        return result;
      } else {
        return this.grantRolebindingCrossPlatformOptions.map((q) => {
          return { value: q.data_key, text: q.data_value };
        });
      }
    },
    deleteCrossTechParameter(index) {
      this.grantRolebindingCrossPlatformSelected.splice(index, 1);
    },
    dataParameterOptions(data) {
      var techProductParameter = this.techProductParameters.find(
        (it) => it.parameter_id === data.id
      );
      if (this.$validate.isObjectValid(techProductParameter)) {
        var techProductParameterId = techProductParameter.data_value;
        var techParameterOptions = data.parameter_options.find(
          (p) => p.data_key === techProductParameterId
        );
        return this.$validate.isObjectValid(techParameterOptions)
          ? techParameterOptions.data_value
          : "";
      }
      return "";
    },
    async onPageLoaded() {
      let result = await techProductService.getTechProductAsync(
        this.$route.params.id
      );
      if (result.status === 200) {
        this.model = result.data;
      } else if (
        (result.status && result.status !== 500) ||
        (result.response && result.response.status !== 500)
      ) {
        this.$utils.notification("error", result.response.data.message, 2000);
      }
      this.techProductParameterOptions = [];
      this.grantRolebindingCrossPlatformOptions = [];
      let resultParam =
        await techProductService.getTechProductParameterOptionsAsync(
          this.$route.params.id
        );
      if (resultParam.status === 200) {
        resultParam.data.forEach((element) => {
          element.selected = { text: "", value: "" };
          this.techProductParameterOptions.push(element);
          if (element.column_key === "application_id") {
            this.grantRolebindingCrossPlatformOptions =
              element.parameter_options;
          }
        });
      } else if (
        resultParam.response &&
        resultParam.response.status !== 500 &&
        resultParam.response.status !== 404
      ) {
        this.$utils.notification(
          "error",
          resultParam.response.data.message,
          2000
        );
      }
    },
    async onStatusSelector(data, paramObj) {
      this.reloadStatusSelector = false;
      paramObj.selected = data;
    },
    async onCrossTechProductSelector(data, item) {
      this.reloadCrossTechProductSelector = false;
      item.custom_param_key = data.text;
      item.custom_param_value = data.value;
    },
    addParameter() {
      this.customParameterOptions.push({
        custom_param_key: "",
        custom_param_value: "",
      });
    },
    deleteParameter(index) {
      this.customParameterOptions.splice(index, 1);
    },
    async onClientAppsSelected(clientAppsId) {
      let result = await clientAppsService.getClientAppAsync(clientAppsId);
      if (result.status === 200) {
        this.clientAppsData = result.data;
      } else if (
        (result.status && result.status !== 500) ||
        (result.response && result.response.status !== 500)
      ) {
        this.$utils.notification("error", result.response.data.message, 2000);
      }
    },
    onBack() {
      if (this.mode == "new" || this.mode == "view") {
        this.$router.push({
          name: "tech_products_detail",
          id: this.$route.params.id,
        });
      } else {
        this.mode = "view";
        this.isShowAccessToken = false;
        this.getTechProductClientAppsDetailAsync();
        this.onPageLoaded();
      }
    },
    async onSubmit() {
      // this.isValidate.status = false;
      // this.isValidate.type = false;

      // if (
      //   this.model.status === "" ||
      //   this.model.status === undefined ||
      //   this.model.status === null
      // ) {
      //   this.isValidate.status = true;
      //   return;
      // }
      if (
        !this.clientAppsData ||
        Object.keys(this.clientAppsData).length == 0
      ) {
        this.$utils.notificationAck("error", "Please select Client Apps");
        return;
      }

      if (this.mode === "new") {
        await this.onSaveCreate();
      } else {
        let isModelChanged = false;
        if (
          JSON.stringify(this.OriginalTechProductParameterOptions) !==
          JSON.stringify(this.techProductParameterOptions)
        ) {
          isModelChanged = true;
        }
        if (
          JSON.stringify(this.OriginalGrantRolebindingCrossPlatformSelected) !==
          JSON.stringify(this.grantRolebindingCrossPlatformSelected)
        ) {
          isModelChanged = true;
        }
        if (
          JSON.stringify(this.OriginalCustomParameterOptions) !==
          JSON.stringify(this.customParameterOptions)
        ) {
          isModelChanged = true;
        }
        if (
          this.OriginalAccessToken.isDefault !== this.accessToken.isDefault ||
          (!this.accessToken.isDefault &&
            this.OriginalAccessToken.ttl !== this.accessToken.ttl)
        ) {
          isModelChanged = true;
        }
        if (this.OriginalAccessToken.isStrictToken !== this.accessToken.isStrictToken) {
          isModelChanged = true;
        }
        if (!isModelChanged && !this.isOauthPayloadChanged) {
          this.$utils.notificationAck(
            "warning",
            "ไม่สามารถดำเนินการได้",
            "ไม่พบข้อมูลที่เปลี่ยนแปลง"
          );
          return;
        }
        this.$utils
          .confirmAlertDisplay(`ต้องการเปลี่ยนแปลงข้อมูลนี้ใช่หรือไม่`)
          .then(async (result) => {
            if (result) await this.onSave();
          });
      }
    },
    async onSave() {
      const vm = this;
      if (this.model.tech_product_type === "OAuth") {
        const isValid =
          await this.$refs.oauthEditor.$refs.addDataForm.validate();
        if (!isValid) {
          return;
        }
      }

      this.$refs.addDataForm.validate().then(async (response) => {
        if (response) {
          this.removeLastAndFirstSpacesFromString();
          var _body = {
            tech_product_id: vm.$route.params.id,
            client_apps_id: vm.clientAppsData.id,
            parameters: [],
            grant_rolebinding_cross_platforms: [],
            access_token_options: {},
          };

          if (vm.model.tech_product_type === "OAuth") {
            _body.valid_oauth_redirect_uris =
              vm.oauthModel.validRedirectURIs.map((val) => {
                return val.uri;
              });

            var channel_allows = [];
            if (vm.oauthModel.channelAllows.OAuth.Facebook)
              channel_allows.push({ channel: "OAuth", type: "Facebook" });
            if (vm.oauthModel.channelAllows.OAuth.Google)
              channel_allows.push({ channel: "OAuth", type: "Google" });
            if (vm.oauthModel.channelAllows.Basic.AD)
              channel_allows.push({ channel: "Basic", type: "AD" });
            if (vm.oauthModel.channelAllows.Basic.Email)
              channel_allows.push({ channel: "Basic", type: "Email" });
            if (vm.oauthModel.channelAllows.Basic.Phone)
              channel_allows.push({ channel: "Basic", type: "Phone" });
            if (vm.oauthModel.channelAllows.Apps.ClientApps)
              channel_allows.push({ channel: "Apps", type: "ClientApps" });

            _body.channel_allows = channel_allows;
          }

          vm.techProductParameterOptions.forEach((element) => {
            _body.parameters.push({
              service_parameter_type: "API",
              parameter_id: element.id,
              data_key: element.column_key,
              data_value: element.selected.value,
            });
          });

          if (
            this.$validate.anyArrayObjectValid(
              vm.grantRolebindingCrossPlatformSelected
            )
          ) {
            let filterGrantRolebindingCrossPlatformSelected =
              vm.grantRolebindingCrossPlatformSelected.filter((q) =>
                this.$validate.isValid(q.custom_param_key)
              );
            filterGrantRolebindingCrossPlatformSelected.forEach((element) => {
              _body.grant_rolebinding_cross_platforms.push({
                data_key: element.custom_param_key,
                data_value: element.custom_param_value,
              });
            });
          }

          if (this.$validate.anyArrayObjectValid(vm.customParameterOptions)) {
            vm.customParameterOptions.forEach((element) => {
              _body.parameters.push({
                service_parameter_type: "Custom",
                parameter_id: "",
                data_key: element.custom_param_key,
                data_value: element.custom_param_value,
              });
            });
          }

          if (
            this.$validate.isObjectValid(vm.accessToken) &&
            !vm.accessToken.isDefault &&
            this.$validate.isValid(vm.accessToken.ttl)
          ) {
            _body.access_token_options.ttl = vm.accessToken.ttl;
          }
          _body.access_token_options.is_strict_token = vm.accessToken.isStrictToken

          const clientAppsId = this.$route.params.client_apps_id;
          let result =
            await techProductService.updateApplyTechProductClientApps(
              vm.$route.params.id,
              clientAppsId,
              _body
            );
          if (result.status === 204) {
            this.$utils.notification("success", "แก้ไขข้อมูลสำเร็จ", 1500);
            this.onBack();
          } else if (
            (result.status && result.status !== 500) ||
            (result.response && result.response.status !== 500)
          ) {
            this.$utils.notificationAck("error", result.response.data.message);
          }
        }
      });
    },
    async onSaveCreate() {
      const vm = this;

      if (this.model.tech_product_type === "OAuth") {
        const isValid =
          await this.$refs.oauthEditor.$refs.addDataForm.validate();
        if (!isValid) {
          return;
        }
      }

      this.$refs.addDataForm.validate().then(async (response) => {
        if (response) {
          this.removeLastAndFirstSpacesFromString();

          var _body = {
            tech_product_id: vm.$route.params.id,
            client_apps_id: vm.clientAppsData.id,
            parameters: [],
            grant_rolebinding_cross_platforms: [],
            access_token_options: {},
          };

          if (vm.model.tech_product_type === "OAuth") {
            _body.valid_oauth_redirect_uris =
              vm.oauthModel.validRedirectURIs.map((val) => {
                return val.uri;
              });

            var channel_allows = [];
            if (vm.oauthModel.channelAllows.OAuth.Facebook)
              channel_allows.push({ channel: "OAuth", type: "Facebook" });
            if (vm.oauthModel.channelAllows.OAuth.Google)
              channel_allows.push({ channel: "OAuth", type: "Google" });
            if (vm.oauthModel.channelAllows.Basic.AD)
              channel_allows.push({ channel: "Basic", type: "AD" });
            if (vm.oauthModel.channelAllows.Basic.Email)
              channel_allows.push({ channel: "Basic", type: "Email" });
            if (vm.oauthModel.channelAllows.Basic.Phone)
              channel_allows.push({ channel: "Basic", type: "Phone" });
            if (vm.oauthModel.channelAllows.Apps.ClientApps)
              channel_allows.push({ channel: "Apps", type: "ClientApps" });

            _body.channel_allows = channel_allows;
          }

          vm.techProductParameterOptions.forEach((element) => {
            _body.parameters.push({
              service_parameter_type: "API",
              parameter_id: element.id,
              data_key: element.column_key,
              data_value: element.selected.value,
            });
          });

          if (
            this.$validate.anyArrayObjectValid(
              vm.grantRolebindingCrossPlatformSelected
            )
          ) {
            let filterGrantRolebindingCrossPlatformSelected =
              vm.grantRolebindingCrossPlatformSelected.filter((q) =>
                this.$validate.isValid(q.custom_param_key)
              );
            filterGrantRolebindingCrossPlatformSelected.forEach((element) => {
              _body.grant_rolebinding_cross_platforms.push({
                data_key: element.custom_param_key,
                data_value: element.custom_param_value,
              });
            });
          }

          if (this.$validate.anyArrayObjectValid(vm.customParameterOptions)) {
            vm.customParameterOptions.forEach((element) => {
              _body.parameters.push({
                service_parameter_type: "Custom",
                parameter_id: "",
                data_key: element.custom_param_key,
                data_value: element.custom_param_value,
              });
            });
          }

          if (
            this.$validate.isObjectValid(vm.accessToken) &&
            !vm.accessToken.isDefault &&
            this.$validate.isValid(vm.accessToken.ttl)
          ) {
            _body.access_token_options.ttl = vm.accessToken.ttl;
          }
          _body.access_token_options.is_strict_token = vm.accessToken.isStrictToken
          let result = await techProductService.applyTechProductClientApps(
            vm.$route.params.id,
            _body
          );
          if (result.status === 201) {
            this.$utils.notification("success", "เพิ่มข้อมูลสำเร็จ", 1500);
            this.onBack();
          } else if (
            (result.status && result.status !== 500) ||
            (result.response && result.response.status !== 500)
          ) {
            this.$utils.notificationAck("error", result.response.data.message);
          } else {
            console.log("result.response.data.message", result.response.data);
            this.$utils.notificationAck("error", result.response.data);
          }
        }
      });
    },
    removeLastAndFirstSpacesFromString() {
      // this.model.display_name = this.model.display_name.trim();
      // this.model.contact_email = this.model.contact_email.trim();
      // this.model.app_namespace = this.model.app_namespace.trim();
    },
    async getTechProductClientAppsDetailAsync() {
      const vm = this;
      const techProductId = this.$route.params.id;
      const clientAppsId = this.$route.params.client_apps_id;
      let result = await techProductService.getTechProductClientAppsDetailAsync(
        techProductId,
        clientAppsId
      );
      if (result.status === 200) {
        this.techProductClientApp = result.data;
        vm.accessToken.isStrictToken = result.data.is_strict_token
        // console.log("techProductClientApp", this.techProductClientApp);

        // if (result.data.apps_config && result.data.apps_config.grant_rolebinding_cross_platforms) {
        //   vm.techProductParameters = result.data.apps_config.grant_rolebinding_cross_platforms.filter(
        //     (it) => it.service_parameter_type === "API"
        //   );
        //   vm.techProductCustomParameters =
        //     result.data.apps_config.grant_rolebinding_cross_platforms.filter(
        //       (it) => it.service_parameter_type === "Custom"
        //     );
        // }
        if (this.$validate.isObjectValid(result.data.apps_config)) {
          if (
            this.$validate.anyArrayObjectValid(
              result.data.apps_config.grant_rolebinding_cross_platforms
            )
          ) {
            vm.grantRolebindingCrossPlatformSelected =
              result.data.apps_config.grant_rolebinding_cross_platforms.map(
                (q) => {
                  return {
                    custom_param_key: q.data_key,
                    custom_param_value: q.data_value,
                  };
                }
              );
          }

          if (
            this.$validate.anyArrayObjectValid(
              result.data.apps_config.grant_rolebinding_cross_platforms
            )
          ) {
            vm.grantRolebindingCrossPlatformSelected =
              result.data.apps_config.grant_rolebinding_cross_platforms.map(
                (q) => {
                  return {
                    custom_param_key: q.data_key,
                    custom_param_value: q.data_value,
                  };
                }
              );
          }

          if (
            this.$validate.isObjectValid(
              result.data.apps_config.access_token_options
            ) &&
            this.$validate.objectValid(
              result.data.apps_config.access_token_options.ttl
            )
          ) {
            vm.accessToken.ttl =
              result.data.apps_config.access_token_options.ttl;
            vm.accessToken.isDefault = false;
          } else {
            vm.accessToken.ttl = 5256000;
            vm.accessToken.isDefault = true;
          }

          if (
            this.$validate.anyArrayObjectValid(
              result.data.apps_config.parameters
            )
          ) {
            vm.techProductParameters =
              result.data.apps_config.parameters.filter(
                (it) => it.service_parameter_type === "API"
              );
            vm.techProductCustomParameters =
              result.data.apps_config.parameters.filter(
                (it) => it.service_parameter_type === "Custom"
              );
          }

          if (
            this.$validate.anyArrayObjectValid(
              result.data.apps_config.valid_oauth_redirect_uris
            )
          ) {
            vm.oauthModel.validRedirectURIs =
              result.data.apps_config.valid_oauth_redirect_uris.map(
                (data, index) => ({
                  id: index,
                  uri: data,
                })
              );
          }

          if (
            this.$validate.anyArrayObjectValid(
              result.data.apps_config.channel_allows
            )
          ) {
            if (result.data.apps_config.channel_allows) {
              vm.oauthModel.channelAllows.Basic.AD =
                result.data.apps_config.channel_allows.find(
                  (p) => p.channel === "Basic" && p.type === "AD"
                ) !== undefined;
              vm.oauthModel.channelAllows.Basic.Email =
                result.data.apps_config.channel_allows.find(
                  (p) => p.channel === "Basic" && p.type === "Email"
                ) !== undefined;
              vm.oauthModel.channelAllows.Basic.Phone =
                result.data.apps_config.channel_allows.find(
                  (p) => p.channel === "Basic" && p.type === "Phone"
                ) !== undefined;
              vm.oauthModel.channelAllows.OAuth.Facebook =
                result.data.apps_config.channel_allows.find(
                  (p) => p.channel === "OAuth" && p.type === "Facebook"
                ) !== undefined;
              vm.oauthModel.channelAllows.OAuth.Google =
                result.data.apps_config.channel_allows.find(
                  (p) => p.channel === "OAuth" && p.type === "Google"
                ) !== undefined;
              vm.oauthModel.channelAllows.Apps.ClientApps =
                result.data.apps_config.channel_allows.find(
                  (p) => p.channel === "Apps" && p.type === "ClientApps"
                ) !== undefined;
            }
          }
        }
        // console.log("getTechProductClientAppsDetailAsync", result);
      } else if (
        (result.status && result.status !== 500) ||
        (result.response && result.response.status !== 500)
      ) {
        this.$utils.notification("error", result.response.data.message, 2000);
      }
    },
    onClickedEditParameters() {
      if (this.$validate.anyArrayObjectValid(this.techProductParameters)) {
        //console.log("onClickedEditParameters", this.techProductParameters);
        const mappedItems = this.techProductParameterOptions.map((it) => {
          let value = "";
          let text = "";
          const selectedItem = this.techProductParameters.find(
            (p) => p.parameter_id === it.id
          );
          if (
            this.$validate.isObjectValid(selectedItem) &&
            this.$validate.containsKey(selectedItem, "data_value")
          ) {
            value = selectedItem.data_value;
            text = it.parameter_options.find(
              (p) => p.data_key === value
            )?.data_value;
          }

          const selected = { value, text };
          return { ...it, selected };
        });
        this.techProductParameterOptions = mappedItems;
      }

      // console.log(mappedItems);

      // console.log(this.customParameterOptions);
      // console.log(this.techProductCustomParameters);
      this.customParameterOptions = this.techProductCustomParameters.map(
        (it) => ({
          custom_param_key: it.data_key,
          custom_param_value: it.data_value,
        })
      );

      this.OriginalTechProductParameterOptions = JSON.parse(
        JSON.stringify(this.techProductParameterOptions)
      );
      this.OriginalGrantRolebindingCrossPlatformSelected = JSON.parse(
        JSON.stringify(this.grantRolebindingCrossPlatformSelected)
      );
      this.OriginalCustomParameterOptions = JSON.parse(
        JSON.stringify(this.customParameterOptions)
      );
      this.OriginalAccessToken = JSON.parse(JSON.stringify(this.accessToken));
      this.mode = "edit";
    },
    async copyText() {
      await this.validateExpiredDateAccessToken();
      let input = document.getElementById("access_token_copy");
      input.select();
      document.execCommand("copy");
      this.textTooltipCopy = "Copied!";
      setTimeout(() => {
        this.textTooltipCopy = "Copy";
      }, 1000);
    },
    async showAccessTokenText() {
      await this.validateExpiredDateAccessToken();
      setTimeout(() => {
        this.isShowAccessToken = !this.isShowAccessToken;
      }, 500);
    },
    async validateExpiredDateAccessToken() {
      if (
        !jwt.validateExpiredDateAccessToken(
          this.techProductClientApp.apps_config.client_access_token
        )
      ) {
        await this.resetAccessToken(false);
      }
    },
    async confirmResetAccessToken() {
      const vm = this;

      this.$utils
        .confirmAlertDisplay(`ต้องการ Access Token ใหม่ ใช่หรือไม่`)
        .then(async (result) => {
          if (result) {
            await this.resetAccessToken();
          }
        });
    },
    async resetAccessToken(isAlert = true) {
      const vm = this;
      const _body = {
        client_apps_allow_service_id: vm.techProductClientApp.id,
      };
      let result = await techProductService.resetTokenTechProductClientApps(
        vm.$route.params.id,
        vm.$route.params.client_apps_id,
        _body
      );
      if (result.status === 201) {
        if (isAlert) {
          vm.$utils.notification("success", "เปลี่ยนข้อมูลสำเร็จ", 1500);
        }
        vm.techProductClientApp.apps_config.client_access_token =
          result.data.access_token;
      } else if (
        (result.status && result.status !== 500) ||
        (result.response && result.response.status !== 500)
      ) {
        vm.$utils.notificationAck("error", result.response.data.message);
      }
    },
  },
};
</script>
